import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { checkAuth } from "../redux/userSlice";
import { api } from "../axios/api";
import { getCachedLicenseStatus, setCachedLicenseStatus, clearCachedLicenseStatus } from "../utils/licenseCache";

const companyId = () => { try { const e=JSON.parse(localStorage.getItem('empresa')||'null'); const u=JSON.parse(localStorage.getItem('user')||'null'); return Number(e?.id||u?.empresa_id)||null; } catch { return null; } };

const ProtectedRoute = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [licenseState, setLicenseState] = useState("checking");
  const { token } = useSelector((state) => state.user);
  const storedToken = localStorage.getItem("token");

  useEffect(() => {
    if (!token && storedToken) {
      dispatch(checkAuth());
    }
  }, [dispatch, token, storedToken]);

  useEffect(() => {
    if (!token && !storedToken) return;
    if (location.pathname === "/licenca-expirada") {
      setLicenseState("valid");
      return;
    }

    let mounted = true;
    if (getCachedLicenseStatus()) {
      setLicenseState("valid");
      return () => {
        mounted = false;
      };
    }

    setLicenseState("checking");
    api.get("/licensas/status", { params: { empresa_id: companyId() } })
      .then((response) => {
        setCachedLicenseStatus(response.data || {});
        if (mounted) setLicenseState("valid");
      })
      .catch(() => {
        clearCachedLicenseStatus();
        if (mounted) setLicenseState("invalid");
      });

    return () => {
      mounted = false;
    };
  }, [location.pathname, storedToken, token]);

  if (!token && !storedToken) {
    return <Navigate to="/login" replace />;
  }

  if (licenseState === "checking") {
    return <div className="license-checking">A validar licença...</div>;
  }

  if (licenseState === "invalid" && location.pathname !== "/licenca-expirada") {
    return <Navigate to="/licenca-expirada" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
